import BaseInputComponent from "basecomponents/BaseInputComponent";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { SmallSpinner } from "../components/loaders";
import { InputField, MultipleSelect, TextArea } from "../components/form";

import {
  createClientPackage,
  clearCurrentPackage,
  updateClientPackage,
  getClientPackageById,
} from "../actions/packageActions";
import {
  getClientArticlesAvailables,
  clearArticle,
} from "../actions/articleActions";

import {
  refreshSelectInputs,
  refreshMultiSelect,
  addOnchangeSelect,
  showPopUp,
  getURLParams,
} from "../utils/domUtils";

import { IPackage } from "../interfaces/IPackage";
import { packages as packageStatus } from "../config/statusConfig";

/**
 * Crear o editar un paquete
 */
class ClientDashboardPackage extends BaseInputComponent {
  state = {
    packageId: null,
    name: "",
    description: "",
    articlesOptions: [],
    needRefreshSelect: false,
    forUpdate: false,
    errors: {},
  };
  packageId = null;
  articles = [];

  componentDidMount() {
    this.assignPackageIdIfNeed();
    // @ts-ignore
    this.props.clearArticle();
    // @ts-ignore
    this.props.clearCurrentPackage();

    // @ts-ignore
    this.props.getClientArticlesAvailables({
      id_package: this.packageId,
    });
    this.checkIfIsEditingMode();
    addOnchangeSelect("articles", () => {
      try {
        // @ts-ignore
        this.articles = $("#articles").val();
      } catch (err) {}
    });
  }

  componentDidUpdate() {
    if (this.articles.length > 0) {
      refreshMultiSelect("articles", this.articles);
    }
    if (!this.state.needRefreshSelect) return;
    refreshSelectInputs();
    this.setState({
      needRefreshSelect: false,
    });
  }

  static getDerivedStateFromProps(nextProps, currentState) {
    let newState = {
      articlesOptions: null,
      needRefreshSelect: null,
      errors: null,
      changed: false,
    };
    if (nextProps.errors) {
      newState.errors = nextProps.errors;
      newState.changed = true;
    }
    if (
      nextProps.article?.elements &&
      nextProps.article.elements.length > 0 &&
      currentState.articlesOptions.length === 0
    ) {
      newState.articlesOptions = nextProps.article.elements.map((e) => ({
        value: e.id,
        label: e.name,
      }));
      newState.needRefreshSelect = true;
      newState.changed = true;
    }

    if (!newState.changed) return null;

    Object.keys(newState).forEach((key) => {
      if (newState[key] === null) {
        delete newState[key];
      }
    });

    return newState;
  }

  assignPackageIdIfNeed() {
    const pageParams = getURLParams();
    const idPackage = pageParams.get("id");
    if (!idPackage) return;

    this.packageId = idPackage;
    this.setState({
      packageId: idPackage,
    });
  }

  checkIfIsEditingMode = () => {
    if (!this.packageId) return;

    // @ts-ignore
    this.props.getClientPackageById(this.packageId, (success) => {
      if (!success) return;
      this.setCurrentPackageFromProps();
    });
  };

  isLoading(): boolean {
    // @ts-ignore
    return this.props.package.loadingOperation === true;
  }

  canEditArticles(): boolean {
    const status = [packageStatus.empty, packageStatus.completing];
    // @ts-ignore
    return status.includes(this.props.package?.item?.status);
  }

  setCurrentPackageFromProps = () => {
    // @ts-ignore
    const currentPackage: IPackage = this.props.package.item;
    if (!currentPackage) return;

    if (currentPackage.articles) {
      this.articles = currentPackage.articles.map((e) => `${e.id}`);
    }

    this.setState({
      packageId: currentPackage.id,
      name: currentPackage.name,
      description: currentPackage.description || "",
      forUpdate: true,
    });
  };

  onSavePackageClick = () => {
    if (this.state.forUpdate) {
      this.onUpdatePackage();
    } else {
      this.onCreateNewPackage();
    }
  };

  onUpdatePackage = () => {
    const { name, description, packageId } = this.state;
    // @ts-ignore
    this.props.updateClientPackage(
      {
        id: packageId,
        name,
        description,
        articles: this.articles,
      },
      (success) => {
        if (success) {
          showPopUp("Paquete actualizado exitosamente!", "");
          this.setCurrentPackageFromProps();
        } else {
          showPopUp(
            "Ocurrio un evento inesperado",
            "No te preocupes, estamos trabajando en solucionarlo cuanto antes, intenta de nuevo en un momento"
          );
        }
      }
    );
  };

  onCreateNewPackage = () => {
    const { name, description } = this.state;
    // @ts-ignore
    this.props.createClientPackage(
      {
        name,
        description,
        articles: this.articles,
      },
      (success) => {
        if (success) {
          showPopUp("Paquete guardado exitosamente!", "");
          this.setCurrentPackageFromProps();
        } else {
          showPopUp(
            "Ocurrio un evento inesperado",
            "No te preocupes, estamos trabajando en solucionarlo cuanto antes, intenta de nuevo en un momento"
          );
        }
      }
    );
  };

  getForm() {
    const { name, description, errors, articlesOptions } = this.state;
    const loading = this.isLoading();
    const canEditArticles = this.canEditArticles();
    return (
      <>
        <InputField
          id="name"
          name="name"
          placeholder="Paquete..."
          value={name}
          error={errors}
          disabled={loading}
          onChange={this.onChangeTextInput}
        />

        <TextArea
          id="description"
          name="description"
          label="Descripcion (opcional)"
          value={description}
          error={errors}
          disabled={loading}
          onChange={this.onChangeTextInput}
        />

        <MultipleSelect
          id="articles"
          label="Articulos"
          options={articlesOptions}
          error={errors}
          disabled={!canEditArticles}
        />

        {loading && <SmallSpinner center={true} />}
      </>
    );
  }

  render() {
    return (
      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header">
              <div className="card-title">
                {this.state.forUpdate ? "Editar paquete" : "Nuevo paquete"}
              </div>
            </div>
            <div className="card-body">{this.getForm()}</div>
            <div className="card-footer">
              <div
                className="btn btn-primary float-right"
                onClick={this.onSavePackageClick}
              >
                Guardar
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// @ts-ignore
ClientDashboardPackage.propTypes = {
  package: PropTypes.object.isRequired,
  getClientArticlesAvailables: PropTypes.func.isRequired,
  createClientPackage: PropTypes.func.isRequired,
  clearCurrentPackage: PropTypes.func.isRequired,
  clearArticle: PropTypes.func.isRequired,
  updateClientPackage: PropTypes.func.isRequired,
  getClientPackageById: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  package: state.package,
  article: state.article,
  errors: state.errors,
});

export default connect(mapStateToProps, {
  getClientArticlesAvailables,
  createClientPackage,
  clearCurrentPackage,
  clearArticle,
  updateClientPackage,
  getClientPackageById,
})(ClientDashboardPackage);
